import { fg } from '@atlaskit/platform-feature-flags';

import { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from '../../default-cloud-graph-comment-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../default-cloud-graph-work-item-entity-ati';
import {
	NounSubtypeKey,
	TypeFilterValueKey,
	type TypeFilterValue3PEntities,
} from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ZendeskIcon } from './icon';
import { ZendeskSearchResultIcon } from './search-result-icon';

const getZendeskTypeFilterConfig = () => {
	const config = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();

	if (fg('rovo_search_zendesk_new_filter')) {
		config.set(TypeFilterValueKey.Ticket, {
			entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
			subTypes3P: [],
		});

		config.set(TypeFilterValueKey.Post, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Post],
		});

		config.set(TypeFilterValueKey.Article, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Article],
		});

		config.set(TypeFilterValueKey.Comment, {
			entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
			subTypes3P: [],
		});
	} else {
		config.set(TypeFilterValueKey.WorkItem, {
			entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
			subTypes3P: [],
		});

		config.set(TypeFilterValueKey.Document, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Document, NounSubtypeKey.Article],
		});
	}

	return config;
};

export const zendeskConfig: ThirdPartyConfig = {
	displayName: 'Zendesk',
	id: 'zendesk',
	icon: get3PLogo(ZendeskIcon, 'Zendesk', 'medium'),
	resourceType: 'zendesk-connector',
	searchResultIcon: get3PLogo(ZendeskSearchResultIcon, 'Zendesk', 'large'),
	integrationAri: 'ari:cloud:platform::integration/zendesk',
	get typeFilterConfig() {
		return getZendeskTypeFilterConfig();
	},
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
